<div class="ps-3">
    <div class="user-mini-profile d-flex align-items-center gap-2 border-bottom">
        @if (isLoggedIn() && user()) {
        <div class="avatar-sm bg-primary text-white d-flex align-items-center justify-content-center flex-shrink-0">
            {{ user()?.email?.charAt(0)?.toUpperCase() }}
        </div>

        <div class="d-none d-md-flex flex-column justify-content-center overflow-hidden">
            <span class="user-email text-truncate fw-semibold">{{user()?.email}}</span>
            <span class="user-role-text text-muted">
                <i class="bi bi-shield-lock me-1"></i>{{userRole()}}
            </span>
        </div>
        } @else {
            <span class="text-muted small">Ospite</span>
        }

    </div>
</div>